'use strict'

import $ from 'jquery'

export default class Carousel {
  constructor () {
    for (var carousel of $('.features-carousel')) {
	    $(carousel).find('.feature-selector').hover((ev) => {
	      var self = $(ev.currentTarget)
	      self.parent().find('.feature-selector').removeClass('active')
	      if (!self.hasClass('active')) {
	        self.addClass('active')
	        let leftSib = self.prev()[0] || self.parent().children().last()[0]
	        let rightSib = self.next()[0] || self.parent().children().first()[0]
	        $($(leftSib).attr('href')).attr('class', 'left')
	        $($(rightSib).attr('href')).attr('class', 'right')
	        $(self.attr('href')).attr('class', '')
	      }
	    }).click((ev) => {
	      ev.preventDefault()
	      return false
	    })

	    $(carousel).find('.feature-image-display > img').click((ev) => {
	      $('a[href="#' + $(ev.currentTarget).attr('id') + '"]').trigger('mouseenter')
	    })
	  }
  }
}
